// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__dwGuY"};